import React, { Component } from 'react';
import Helmet from 'react-helmet';
import map from 'lodash/map';

// import range from 'lodash/range';
import sampleSize from 'lodash/sampleSize';
import shuffle from 'lodash/shuffle';
import slice from 'lodash/slice';
import Image from '../components/Image';
import WorkNav from '../components/WorkNav';
import Loader from '../components/Loader';
import Animated from '../components/Animated';

import {
  wrapper,
  fullWidth,
  // halfWidth,
  thirdWidth,
  imageWrapper,
  textContainer,
} from '../styles';

const row1 = (image, index) => {
  return (
    <div {...fullWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

// const row2 = (image, index) => {
//   return (
//     <div {...halfWidth} key={`image-${index}`}>
//       <Image sources={image} />
//     </div>
//   );
// };

const row3 = (image, index) => {
  return (
    <div {...thirdWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

class Blom extends Component {
  constructor(props) {
    super(props);
    this.state = { set1: [], set2: [] };
  }

  componentWillMount() {
    this.props.load();
    this.props.loadTheme();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.blom && nextProps.blom.images && !this.state.set1.length) {
      const { images } = nextProps.blom;
      let set1 = slice(images, 1, 69);
      let set2 = slice(images, 69, images.length - 1);
      set1 = sampleSize(set1, 12);
      set2 = sampleSize(shuffle(set2), 12);
      this.setState({ set1, set2 });
    }
  }

  render() {
    const { blom } = this.props;
    if (!blom || !blom.images) {
      return <Loader />;
    }

    const allImages = blom.images;
    const { set1, set2 } = this.state;
    const { prev, next } = this.props;
    return (
      <div>
        <Helmet
          title="Blóm by lucastswick"
          description="Blóm is a generative art series that draws abstract roses."
          meta={[
            {
              property: 'og:image:url',
              content: `https://generativeartist.com${allImages[0][2].srcSet}`,
            },
            {
              property: 'twitter:image',
              content: `https://generativeartist.com${allImages[0][2].srcSet}`,
            },
          ]}
        />
        <div {...textContainer}>
          <Animated as="h1">Blóm</Animated>
          <Animated delay={150}>
            Blóm is a generative art series that draws abstract roses.
          </Animated>
          <Animated delay={300}>
            I developed an algorithm that mimics my illustration process. Like a
            typical algorithm, it accepts many different values, but unlike a
            typical algorithm it spits out pixels instead of numbers.
          </Animated>
          <Animated delay={450}>
            Here's one of the first images I was happy with:
          </Animated>
          <div {...imageWrapper}>{row1(allImages[0], 0)}</div>
          <Animated>
            I let the computer pick random numbers and run over night, and
            typically wake up to a few thousand images. I select the ones I
            like, and tweak and iterate the algorithm in a sort of collaborative
            process with the computer.
          </Animated>
          <Animated>
            I may have gone a little overboard in creating iterations, but the
            truth is it's a lot of fun. The computer often suprises me, probably
            a little like some parents whose kids grow up to be astronauts.
          </Animated>
          <Animated>Here are a few of my favorites:</Animated>
        </div>
        <div {...wrapper}>
          {map(set1, (image, index) => {
            if (index % 4 === 0) {
              return row1(image, index);
            } else {
              return row3(image, index);
            }
          })}
        </div>
        <div {...textContainer}>
          <Animated as="h1">Blóm version 2</Animated>
          <Animated>
            Some of the iterations felt more water-like, and I wanted to lean
            into the quality of smooth, flowing imagery.
          </Animated>
          <Animated>
            Spin up the Hadron Collider I've got some art to make!
          </Animated>
        </div>
        <div {...wrapper}>
          {map(set2, (image, index) => {
            if (index % 4 === 0) {
              return row1(image, index);
            } else {
              return row3(image, index);
            }
          })}
        </div>

        <WorkNav prev={prev} next={next} />
      </div>
    );
  }
}

export default Blom;



// WEBPACK FOOTER //
// ./src/pages/BlomArchive.js